import { Injectable } from '@angular/core';

/**
 * Preferências de visualização de listagens, guardadas no browser por listagem.
 */
@Injectable({
  providedIn: 'root'
})
export class ListPreferencesService {
  private readonly keyPrefix = 'maresias.list';

  readPageSize(list: string, allowedSizes: readonly number[], fallback: number): number {
    const stored = this.read(this.pageSizeKey(list));
    const parsed = stored === null ? Number.NaN : Number(stored);

    return allowedSizes.includes(parsed) ? parsed : fallback;
  }

  writePageSize(list: string, pageSize: number): void {
    this.write(this.pageSizeKey(list), String(pageSize));
  }

  private pageSizeKey(list: string): string {
    return `${this.keyPrefix}.${list}.pageSize`;
  }

  // Storage pode lançar mesmo existindo (modo privado do Safari lança no set, quota
  // estourada lança em qualquer escrita). Preferência é acessório: perdê-la não pode
  // derrubar a tela que só queria saber quantos itens exibir.
  private read(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  private write(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      return;
    }
  }
}
